<script setup>
	import { defineProps } from 'vue'

	const props = defineProps({
		item: Object,
		required: true
	})

	const emit = defineEmits(['add'])

	function currencyFormat(value) {
	  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)
	}

	function handleAddClick() {
	  emit('add', { item: props.item })
	}

</script>

<template>
	<div class="item">
	    <div class="w-[100%] relative after:content-[''] after:pt-[70%] after:block">
	      <img 
	        v-lazy="{ 
	          src: item.photo, 
	          loading: 'img/image_loader.gif', 
	          error: 'img/no_image.png' 
	        }" 
	      />
	    </div>
	    <h2>{{ item.title }}</h2>
	    <div class="flex items-center">
	    	<span>{{ currencyFormat(item.price) }}</span>
	    	<button @click="handleAddClick">+</button>
	    </div>
	</div>
</template>

<style scoped>
	/*
    **ITEM CARD
    */
    .item {
        @apply bg-white dark:bg-zinc-700 mx-1 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50;
    }
    .item img {
       @apply absolute top-0 left-0 w-full h-full object-cover rounded-t-3xl;
    }

    .item h2 {
        @apply text-sm font-semibold mt-3 mx-3;
    }

    .item span {
        @apply text-sm font-semibold text-[var(--color)] mx-3 mb-3;
    }

    .item button {
        @apply text-white rounded-full bg-[var(--color)] shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 w-7 h-7 ml-auto mx-3 mb-3;
    }
</style>